import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "reports/store-health-dashboard/view-report",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const storeHealthView = require("./StoreHealthView").default;
          cb(null, storeHealthView);
        },
        "StoreManagement"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/StoreHealthDashboard/ViewReport/index.js